<script setup>
import { ref } from 'vue';
import { __, getAccountByNumber } from '@/utils';
import Modal from "@components/modal.vue";
import OtpCode from "@components/otp-code.vue";
import Loader from '@components/loader.vue';
import ResendOTP from '@components/ResendOTP.vue';
import { useField } from 'vee-validate';

const loader = ref(false);
const otpCode = ref('');
const otpError = ref(false)

const { values, OTPphone } = defineProps({
    showOTPPopup: Boolean,
    handleModalClose: Function,
    values: Object,
	OTPphone: String,
});

const { handleChange: setToken } = useField('accountToken');
const { handleChange: setSubscriberID } = useField('SubscriberID');

const emit = defineEmits(['error', 'response', 'phone', 'success', 'OTPphone']);

const validateCode = async () => {
    loader.value = true;
    const response = await getAccountByNumber({
        code: otpCode.value,
        msisdn: values.msisdn
    });
    loader.value = false;

    const responseObj = JSON.parse(response.data);

    if(responseObj?.response?.status) {
		const subscriberId = Object.keys(responseObj?.response?.subscribers).find(key => responseObj?.response?.subscribers[key] === values.msisdn);
        emit('success', values.msisdn)
		setToken(responseObj?.response?.token);
		setSubscriberID(subscriberId);
    } else {
        otpError.value = true;
    }
}
</script>
<template>
    <Modal :isActive="showOTPPopup" @close="handleModalClose">
		<template #body>
			<div class="notice-verification">
				<div class="notice__body">
					<p>
                        <strong>{{ __("We sent an SMS message with a verification code to the account holder's phone") }}</strong><br />
						{{ OTPphone }}<br />
						<strong>{{ __('Please enter the 4 digits you received here.') }}</strong>
					</p>
				</div><!-- /.notice__body -->

				<div class="notice__field">
					<div class="field-code">
						<div class="field__controls">
							<OtpCode @changed="otpCode = $event" />
						</div><!-- /.field__controls -->

                        <p v-if="otpError" style="color: #E50000;">
							{{ __('Incorrect code entered. Please try again.') }}
						</p>

						<ResendOTP 
                            :msisdn="values.msisdn"
                            :loader="loader"
                            @loader="loader = $event"
                        />
					</div><!-- /.field-code -->
				</div><!-- /.notice__field -->

				<div class="notice__actions">
					<button class="notice__btn btn" @click="validateCode" :disabled="otpCode.length < 4 || loader" type="button">
						{{ __('Confirmation and activation') }} <Loader v-if="loader && showOTPPopup" />
					</button><!-- /.btn -->
					<slot name="actions" />
				</div><!-- /.notice__actions -->
			</div><!-- /.notice-verification -->
		</template>
	</Modal>
</template>